import { ecommerceApiTokenApi, GetTokenRequest, StorefrontAPITokenResponse } from 'components/discovery/shared/ecommerce-api-token/api/ecommerce-api-token-api.js'
import { FAKE, REAL, registerDependency } from 'components/shared/dependency-injection/dependency-injection.js'
import { createSignal } from '@cloudsuite/mosaic-shared/scripts/signals.js'
import { validate } from 'typia'
import { validationError } from 'components/discovery/shared/validation.js'

export class EcommerceApiTokenStore {
  token: () => string | null
  private setToken: (value: string | null) => void

  private tokenEndpoint = ''
  private tokenPromise: Promise<void> | null = null

  constructor() {
    [this.token, this.setToken] = createSignal<string | null>(null)
  }

  ensureToken = async (tokenEndpoint: string) => {
    if (!tokenEndpoint) return
    if (this.token() && this.tokenEndpoint === tokenEndpoint) return
    if (this.tokenPromise && this.tokenEndpoint === tokenEndpoint) return this.tokenPromise

    this.tokenEndpoint = tokenEndpoint
    this.tokenPromise = this.fetchToken(tokenEndpoint).finally(() => {
      this.tokenPromise = null
    })
    return this.tokenPromise
  }

  private fetchToken = async (tokenEndpoint: string) => {
    const response = await ecommerceApiTokenApi.getToken(new GetTokenRequest(tokenEndpoint))
    const tokenValidation = validate<StorefrontAPITokenResponse>(response)
    if (tokenValidation.success) {
      this.setToken(tokenValidation.data.token)
    } else {
      validationError('StorefrontAPITokenResponse', tokenValidation.errors)
    }
  }
}

export let ecommerceApiTokenStore!: EcommerceApiTokenStore
registerDependency({
  [REAL]: () => ecommerceApiTokenStore = new EcommerceApiTokenStore(),
  [FAKE]: () => ecommerceApiTokenStore = new EcommerceApiTokenStore(),
})
